import { useEffect } from 'react';

type SeoOptions = {
  title: string;
  description: string;
  keywords: string;
  path: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
};

const SITE_ORIGIN = 'https://flpro.cn';
const JSON_LD_ID = 'page-jsonld';

function setMeta(attr: 'name' | 'property', key: string, value: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}

function setCanonical(href: string) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function useSeo({ title, description, keywords, path, jsonLd }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    const url = `${SITE_ORIGIN}${path}`;

    setMeta('name', 'description', description);
    setMeta('name', 'keywords', keywords);
    setMeta('name', 'robots', 'index,follow,max-image-preview:large');
    setCanonical(url);

    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', '爆料官网');
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);

    const previous = document.getElementById(JSON_LD_ID);
    if (previous) previous.remove();
    if (jsonLd) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = JSON_LD_ID;
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, keywords, path, jsonLd]);
}

export const siteOrigin = SITE_ORIGIN;